import PropTypes from 'prop-types';
import { Modal, ConfirmationModalContent } from '@hsl-fi/dialog';
import { jsx } from 'react/jsx-runtime';

const DialogModal = ({
  headerText,
  dialogContent,
  handleClose = () => {},
  primaryButtonText,
  primaryButtonOnClick,
  primaryButtonVariant,
  secondaryButtonText,
  secondaryButtonOnClick,
  lang,
  isModalOpen
}) => {
  return /*#__PURE__*/jsx(Modal, {
    lang: lang,
    open: isModalOpen,
    onOpenChange: open => {
      if (!open) {
        handleClose();
      }
    },
    children: /*#__PURE__*/jsx(ConfirmationModalContent, {
      title: headerText,
      description: dialogContent,
      confirmLabel: primaryButtonText,
      confirmVariant: primaryButtonVariant,
      onConfirm: primaryButtonOnClick,
      cancelLabel: secondaryButtonText,
      onCancel: secondaryButtonOnClick
    })
  });
};
process.env.NODE_ENV !== "production" ? DialogModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  headerText: PropTypes.string.isRequired,
  handleClose: PropTypes.func,
  primaryButtonText: PropTypes.string.isRequired,
  primaryButtonOnClick: PropTypes.func.isRequired,
  primaryButtonVariant: PropTypes.oneOf(['primary', 'secondary', 'success', 'destructive', 'plain']),
  secondaryButtonText: PropTypes.string,
  secondaryButtonOnClick: PropTypes.func,
  dialogContent: PropTypes.string,
  lang: PropTypes.string.isRequired
} : void 0;

export { DialogModal as default };
//# sourceMappingURL=index.js.map
